// Matriz cliente de planes — coincide con /app/backend/plans.py
// Decisión: TODOS los planes incluyen toda la funcionalidad de compliance.
// Diferenciación por CAPACIDAD y SLA, no por features.

export const PLAN_ORDER = ['pyme', 'empresas', 'enterprise'];

export const PLANS = {
  pyme: {
    key: 'pyme',
    name: 'PyME',
    level: 1,
    size: 'Empresas medianas',
    price: '2 UF',
    priceHint: '+ IVA · por mes',
    color: '#2A9B68',
    quotas: {
      titulares: '1 millón',
      rats: 50,
      users: 5,
      cmp_domains: 1,
      dpia_year: 5,
      breaches_year: 10,
      copilot_msgs: 250,
      sla: '48h hábiles',
    },
  },
  empresas: {
    key: 'empresas',
    name: 'Empresas',
    level: 2,
    size: 'Corporativos medianos y grandes',
    price: '6 UF',
    priceHint: '+ IVA · por mes',
    color: '#143A34',
    quotas: {
      titulares: '10 millones',
      rats: 300,
      users: 20,
      cmp_domains: 5,
      dpia_year: 30,
      breaches_year: 50,
      copilot_msgs: 1500,
      sla: '8h hábiles',
    },
  },
  enterprise: {
    key: 'enterprise',
    name: 'Enterprise',
    level: 3,
    size: 'Holdings, banca, retail nacional',
    price: 'A cotización',
    priceHint: 'Anual · según volumen de datos',
    color: '#0B1220',
    quotas: {
      titulares: 'Sin tope',
      rats: 'Sin tope',
      users: 'Sin tope',
      cmp_domains: 'Sin tope',
      dpia_year: 'Sin tope',
      breaches_year: 'Sin tope',
      copilot_msgs: 'Sin tope',
      sla: '4h · Success Manager',
    },
  },
};

// Solo estas 3 features están realmente gateadas (arquitectura Enterprise).
export const FEATURE_MIN_PLAN = {
  whitelabel: 'enterprise',
  sso: 'enterprise',
  multi_tenant: 'enterprise',
};

export const FEATURE_LABEL = {
  whitelabel: 'White-label completo',
  sso: 'SSO / SAML corporativo',
  multi_tenant: 'Multi-tenant padre/hijo',
};

// Todos los módulos son visibles y usables en todos los planes.
export const INCLUDED_IN_ALL = [
  'Diagnóstico completo + score 0-100',
  'Plan de acción priorizado detallado',
  'RAT completo con wizard IA',
  'Documentos legales generados con IA',
  'Portal ARCO+ público con SLA 15 días hábiles',
  'Brechas 72h · workflow de 6 etapas · plantillas Art. 25',
  'DPIA con matriz 5×5 y firma DPO',
  'Cookies (CMP) embebible',
  'Trazabilidad completa + import CSV',
  'Catastro de sistemas',
  'Carpeta de Fiscalización · ZIP SHA-256',
  'Rol Auditor Externo con caducidad',
  'Copiloto IA especializado en Ley 21.719',
];

export const PLAN_STATUS_LABEL = {
  trial:     'Prueba',
  active:    'Activo',
  suspended: 'Suspendido',
  expired:   'Vencido',
};

export function isOrgActive(org) {
  if (!org) return false;
  if (org.plan_status !== 'active') return false;
  if (!org.plan_expires_at) return true;
  try {
    const d = new Date(org.plan_expires_at);
    return d.getTime() > Date.now();
  } catch { return true; }
}

export function planStatusEffective(org) {
  if (!org) return 'trial';
  const s = org.plan_status || 'trial';
  if (s !== 'active') return s;
  if (!org.plan_expires_at) return 'active';
  try {
    const d = new Date(org.plan_expires_at);
    return d.getTime() > Date.now() ? 'active' : 'expired';
  } catch { return 'active'; }
}

// Módulos que un cliente en modo Trial NO puede usar todavía.
// La lista se mantiene sincronizada con TRIAL_ALLOWED_PREFIXES del backend.
export const TRIAL_LOCKED_ROUTES = new Set([
  '/app/plan',
  '/app/rat',
  '/app/documentos',
  '/app/arco',
  '/app/brechas',
  '/app/dpia',
  '/app/cookies',
  '/app/sistemas',
  '/app/trazabilidad',
  '/app/fiscalizacion',
  '/app/equipo',
]);

export function isRouteLockedForTrial(route, org) {
  if (isOrgActive(org)) return false;
  return TRIAL_LOCKED_ROUTES.has(route);
}

export function planLevel(planKey) {
  return PLANS[planKey]?.level ?? 1;
}

export function hasFeature(org, featureKey) {
  const planKey = normalizePlan(org?.plan);
  const minPlan = FEATURE_MIN_PLAN[featureKey];
  if (!minPlan) return true;
  return planLevel(planKey) >= planLevel(minPlan);
}

export function minPlanFor(featureKey) {
  const key = FEATURE_MIN_PLAN[featureKey];
  return PLANS[key];
}

// Convertir planes antiguos al nuevo modelo
export function normalizePlan(planKey) {
  if (!planKey) return 'pyme';
  if (planKey === 'starter') return 'pyme';
  if (planKey === 'business') return 'empresas';
  if (!PLANS[planKey]) return 'pyme';
  return planKey;
}
